import { render } from "./MobileInformation.vue?vue&type=template&id=705b45c2&scoped=true"
import script from "./MobileInformation.vue?vue&type=script&lang=js"
export * from "./MobileInformation.vue?vue&type=script&lang=js"

import "./MobileInformation.vue?vue&type=style&index=0&id=705b45c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705b45c2"]])

export default __exports__